export var getCardinalBoundsFromInterCardinalBounds = function (_a) {
    var ne = _a.ne, sw = _a.sw;
    return getCardinalBoundsFromBoundingBox([ne.lat, ne.lng, sw.lat, sw.lng]);
};
export var getCardinalBoundsFromBoundingBox = function (boundingBox) {
    var n = {
        lat: boundingBox[0],
        lng: boundingBox[3] + ((boundingBox[1] - boundingBox[3]) / 2)
    };
    var e = {
        lat: boundingBox[2] + ((boundingBox[0] - boundingBox[2]) / 2),
        lng: boundingBox[1]
    };
    var s = {
        lat: boundingBox[2],
        lng: boundingBox[3] + ((boundingBox[1] - boundingBox[3]) / 2)
    };
    var w = {
        lat: boundingBox[2] + ((boundingBox[0] - boundingBox[2]) / 2),
        lng: boundingBox[3]
    };
    return { n: n, e: e, s: s, w: w };
};
